var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_5583_681","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"20","height":"21","key":0},React.createElement("rect",{"y":"0.5","width":"20","height":"20","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_5583_681)","key":1},React.createElement("path",{"d":"M6.0625 15.5L5 14.4375L8.9375 10.5L5 6.5625L6.0625 5.5L10 9.4375L13.9375 5.5L15 6.5625L11.0625 10.5L15 14.4375L13.9375 15.5L10 11.5625L6.0625 15.5Z","fill":"#B8B7B7"}))]);
}

Close.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = Close;

Close.default = Close;
